import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthorizationService } from '../authorization/authorization.service';
import { User } from '@precisely/prism-ng/user-account';
import { map } from 'rxjs/operators';
import { OKTA_AUTH } from '@okta/okta-angular';
import { ConfigurationService } from '../shared/configuration-service/configuration.service';
import { OktaAuth } from '@okta/okta-auth-js';
import { APP_WINDOW, AppWindow } from '../AppWindow';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @HostBinding('class.site-header') isHeader = true;
  public helpUrl: string = '';
  public user$: Observable<User> = new BehaviorSubject<User>({});
  public trialUrl =
    'https://digital-trial.onboarding.cloud.precisely.com/signup?moduleName=geo-addressing';

  constructor(
    private _authorizationService: AuthorizationService,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    @Inject(APP_WINDOW) private _window: AppWindow,
    private _configurationService: ConfigurationService,
  ) {}

  ngOnInit() {
    this.helpUrl = this._configurationService.getConfiguration().helpUrl;
    this.user$ = this._authorizationService.principal$.pipe(
      map((principal) =>
        principal?.identity?.isAuthenticated
          ? {
              firstName: principal.identity.givenName,
              lastName: principal.identity.surname,
              email: principal.identity.username,
            }
          : {},
      ),
    );
  }
  async onSignOut() {
    await this.oktaAuth.signOut({
      postLogoutRedirectUri: this._window.location.origin + '/logout',
    });
  }
}
